import {
  ApplicationConfig,
  importProvidersFrom, inject,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from "@angular/core"
import { provideRouter } from "@angular/router"
import { appRoutes } from "./app.routes"
import { environment } from "../environments/environment"
import { getStorage, provideStorage } from "@angular/fire/storage"
import { getRemoteConfig, provideRemoteConfig } from "@angular/fire/remote-config"
import { getAuth, provideAuth } from "@angular/fire/auth"
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http"
import { AuthTokenHttpInterceptorProvider } from "./http-interceptors/auth-token.interceptor"
import { HttpErrorInterceptorProvider } from "./http-interceptors/http-error.interceptor"
import { getApp, initializeApp, provideFirebaseApp } from "@angular/fire/app"
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  provideFirestore,
} from "@angular/fire/firestore"
import { Analytics, getAnalytics, provideAnalytics, setUserProperties } from "@angular/fire/analytics"
import { provideAnimations } from "@angular/platform-browser/animations"
import { GoogleMapsModule } from "@angular/google-maps"

export const appConfig: ApplicationConfig = {
  providers: [

    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    // provideFirestore(() => getFirestore()),
    provideFirestore(() => initializeFirestore(
      getApp(),
      { localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }) }),
    ),
    provideStorage(() => getStorage()),
    provideAnalytics(() => getAnalytics()),
    provideRemoteConfig(() => getRemoteConfig()),
    provideAnimations(),
    // provideAnimationsAsync(),
    importProvidersFrom(
      GoogleMapsModule,
      // BrowserAnimationsModule,
      // BrowserModule,
      // AuthGuard,
      // NgxMapboxGLModule.withConfig({ accessToken: environment.mapboxConfig.token }),
    ),
    {
      provide: "GOOGLE_MAPS_API_KEY",
      useValue: environment.firebaseConfig.apiKey, // or your specific Google Maps API key
    },
    provideZonelessChangeDetection(),
    // provideExperimentalZonelessChangeDetection(), // mapBox map does not render
    // provideZoneChangeDetection({ eventCoalescing: true }),
    // provideClientHydration(withEventReplay()),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(
      appRoutes,
      // withEnabledBlockingInitialNavigation(), // for SSR
      // withViewTransitions(), // needs some kind of filter for pages only, makes rendering nested views very slow
    ),
    AuthTokenHttpInterceptorProvider,
    HttpErrorInterceptorProvider,

    provideAppInitializer(() => {
      const analyticsInstance = inject(Analytics);
      const parts = window.location.hostname.split('.');
      const subdomain = parts.length > 2 ? parts[0] : 'root_or_local';

      // Default fallback catch-all dimension prior to login completion
      setUserProperties(analyticsInstance, {
        tenant_subdomain: subdomain
      });
    }),

  ],
}
